import {otsBaseApi} from "../../ots-api";
import {
  AuditObjectAuditSummary,
  AuditObjectAuditView,
  TtaAuditSummaryRequest,
  USER_REQUESTED_AUDIT_RUN
} from "../../../model/tta-audit-summary";
import {removeUndefined} from "../../../util/util";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["TtaAuditSummaries", "TtaAuditViews"]});

export const ttaAuditApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    /** Latest audit summaries for a set of tickets, in one request. Tickets never audited come back with `hasAuditRun: false`. */
    getTtaAuditSummaries: builder.query<AuditObjectAuditSummary[], TtaAuditSummaryRequest>({
      query: (body) => ({
        url: `/ttas/audit/summary`,
        method: "POST",
        body,
      }),
      providesTags: [{type: "TtaAuditSummaries", id: "LIST"}],
      keepUnusedDataFor: 120,
    }),
    /** One ticket's latest audit with its findings. */
    getTtaAuditView: builder.query<AuditObjectAuditView, {id: string, tenantCode?: string}>({
      query: ({id, tenantCode}) => ({
        url: `/ttas/${encodeURIComponent(id)}/audit`,
        method: "GET",
        params: removeUndefined({tenantCode}),
      }),
      providesTags: (_result, _error, {id}) => [{type: "TtaAuditViews", id}],
    }),
    /** Audits a ticket now, as WaterGo's Run Audit does; its summary and findings refresh afterwards. */
    runTtaAudit: builder.mutation<AuditObjectAuditView, {id: string, tenantCode?: string}>({
      query: ({id, tenantCode}) => ({
        url: `/ttas/${encodeURIComponent(id)}/audit/run`,
        method: "POST",
        params: removeUndefined({tenantCode}),
        body: USER_REQUESTED_AUDIT_RUN,
      }),
      invalidatesTags: (_result, _error, {id}) => [{type: "TtaAuditViews", id}, {type: "TtaAuditSummaries", id: "LIST"}],
    }),
  })
});

export const {
  useGetTtaAuditSummariesQuery,
  useLazyGetTtaAuditSummariesQuery,
  useGetTtaAuditViewQuery,
  useRunTtaAuditMutation,
} = ttaAuditApi;
